import React, { useEffect, useState } from "react";
import t from "../../../helpers/t";
import { Biscuit } from "../../../../utils";
import { voucherTypesActions, useSelector } from "inbooma-api";
import ItemLoginWeb from "../viewItems/ItemLoginWeb";
import ItemLoginMobile from "../viewItems/ItemLoginMobile";

const VoucherLoginListItem = (props) => {
  const { dispatch, voucherLogin, setInitialized, onRemoveVoucherLogin, showNotification, index } =
    props;
  let language = Biscuit.get("user.lang").replace("-", "_");
  const currentUrl = new URL(window.location.href);
  const [localVoucherLogin, setLocalVoucherLogin] = useState(voucherLogin);
  const [voucherLoginPending, setVoucherLoginPending] = useState(null);
  const _editVoucherLogin = useSelector((state) => state["voucher_types_data"].editVoucherLogin);
  useEffect(() => {
    if (_editVoucherLogin.success === "" || !voucherLoginPending) {
      return;
    }

    if (_editVoucherLogin.success === true) {
      let clone = { ...localVoucherLogin };
      clone.valid = _editVoucherLogin.data.valid;
      setLocalVoucherLogin(clone);
      showNotification("success", localVoucherLogin.username);
    } else {
      showNotification(
        "warning",
        null,
        typeof _editVoucherLogin.data.message !== "undefined"
          ? _editVoucherLogin.data.message
          : t("could_not_be_saved_${a}", { a: t("voucher") }, "capital") +
              " " +
              _editVoucherLogin.username,
      );
      console.log("Failed patching voucher!");
    }
    setVoucherLoginPending(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_editVoucherLogin]);

  const onChangeStatus = (valid, voucherLogin) => {
    dispatch(
      voucherTypesActions.editVoucherLogin({
        id: voucherLogin,
        data: {
          valid: status.currentTarget.checked,
        },
        token: Biscuit.get("token"),
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    setVoucherLoginPending(voucherLogin);
  };

  return (
    <>
      <ItemLoginWeb
        localVoucherLogin={localVoucherLogin}
        key={"item_" + localVoucherLogin.username + "_web"}
        setInitialized={setInitialized}
        voucherLoginPending={voucherLoginPending}
        onChangeStatus={onChangeStatus}
        currentUrl={currentUrl}
        onRemoveVoucherLogin={onRemoveVoucherLogin}
        index={index}
      />
      <ItemLoginMobile
        localVoucherLogin={localVoucherLogin}
        key={"item_" + localVoucherLogin.username + "_web"}
        setInitialized={setInitialized}
        voucherLoginPending={voucherLoginPending}
        onChangeStatus={onChangeStatus}
        currentUrl={currentUrl}
        onRemoveVoucherLogin={onRemoveVoucherLogin}
        index={index}
      />
    </>
  );
};

export default VoucherLoginListItem;
